// extracted by mini-css-extract-plugin
export default {"tableWrapper":"schedule-list_tableWrapper__TrHMu"};